import React, { useEffect, useState } from "react";
import CustomDraggable from "Common/CustomDraggable/CustomDraggable";
import CustomLabel from "Common/CustomLabel/CustomLabel";
import CustomSelect from "Common/CustomSelect";
import CustomTextarea from "Common/CustomTextArea";
import PopupFooter from "Components/PopupFooter/PopupFooter";
import PopupHeader from "Components/PopupHeader/PopupHeader";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import api from "http";
import { toast } from "react-toastify";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import NumberConversion from "Utils/NumberConversion";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
const NewClaimStatusPopup = ({ onClose, disableDraggable, row }) => {
  const [visitStatuses, setVisitStatuses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const UNIQUE_ID = "NewClaimStatusPopup";
  const [state, setState] = useState({
    visitId: row?.id || 0,
    claimStatusCode: row?.claimStatusCode || "",
    responsibleParty: row?.responsibleParty || "",
    notes: "",
  });
  const handleChange = (e) => {
    let { name, value } = e.target;
    // Limit notes to 500 characters

    if (name === "claimStatusCode") {
      switch (value) {
        case "B_S":
          setState((prev) => ({ ...prev, responsibleParty: "Secondary" }));
          break;
        case "B_T":
          setState((prev) => ({ ...prev, responsibleParty: "Tertiary" }));
          break;
        case "B_PAT":
          setState((prev) => ({ ...prev, responsibleParty: "Patient" }));
          break;
        default:
          setState((prev) => ({ ...prev, responsibleParty: state.responsibleParty }));
          break;
      }
    }

    if (name === "notes" && value.length > 500) {
      value = value.slice(0, 500);
    }
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const handleSave = async () => {
    try {
      setIsLoading(true);
      await api.post(
        `${process.env.REACT_APP_TC_PMS}/api/Visit/ManualClaimStatusUpdate`,
        state
      );
      toast.success("Claim status updated successfully");
      onClose();
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    (async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisitStatusCodes`
        );
        setVisitStatuses(response.data.dataModel);
      } catch (error) {
        ErrorHandlingMessage(error);
      }
    })();
  }, [
    row.secondaryStatus,
    row.tertiaryStatus,
    row.claimStatusCode,
    row.patientStatus,
    row.primaryStatus,
  ]);

  return (
    // wrapperId == any unique id , for uniqueness give componentname as a wrapperID
    <ReactPortal wrapperId={UNIQUE_ID}>
      {isLoading && <FullPageLoader allowFullScreen />}
      <div
        data-te-modal-init
        className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
        id="exampleModalScrollable"
        tabIndex={-1}
        aria-labelledby="exampleModalScrollableLabel"
        aria-modal="true"
        data-te-open="true"
      >
        <CustomDraggable
          disableDraggable={disableDraggable}
          handle={`#${UNIQUE_ID}`}
        >
          <div
            data-te-modal-dialog-ref
            className="relative w-[900px]   min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
          >
            <div className="p-10 pt-0 ">
              <PopupHeader uniqueId={UNIQUE_ID} heading="New Claim Status" />
              <div className=" overflow-y-auto max-h-[70vh]">
                <div className="grid grid-cols-12 gap-4 pb-4 mb-4 border-b border-gray-200">
                  <div className="col-span-4 space-y-2">
                    <CustomLabel label="Current Claim Status" />
                    <div className="p-2 text-sm text-gray-500 bg-gray-100 rounded-md">
                      {row.claimStatusDescription}
                    </div>
                  </div>
                  <div className="col-span-4 space-y-2">
                    <CustomLabel label="Current Responsible Party  " />
                    <div className="p-2 text-sm text-gray-500 bg-gray-100 rounded-md">
                      {row.responsibleParty}
                    </div>
                  </div>
                  <div className="col-span-4 space-y-2">
                    <CustomLabel label="Current Claim Balance" />
                    <div className="p-2 text-sm text-gray-500 bg-gray-100 rounded-md">
                      {NumberConversion(row.amountDue)}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-6 ">
                    <CustomSelect
                      value={state.claimStatusCode}
                      name="claimStatusCode"
                      onChange={handleChange}
                      label="Claim Status"
                      children={row.claimStatusCode}
                    >
                      {visitStatuses
                        .filter((item) => item.isClaimStatus)
                        .map((item) => (
                          <option key={item.statusCode} value={item.statusCode}>
                            {item.statusDescription}
                          </option>
                        ))}
                    </CustomSelect>
                  </div>
                  <div className="col-span-6">
                    <CustomSelect
                      value={state.responsibleParty}
                      name="responsibleParty"
                      onChange={handleChange}
                      label="Responsible Party"
                      children={row.responsibleParty}
                    >
                      <option>Primary</option>
                      <option>Secondary</option>
                      <option>Tertiary</option>
                      <option>Patient</option>
                      <option>None</option>
                    </CustomSelect>
                  </div>
                  <div className="col-span-12">
                    <CustomTextarea
                      value={state.notes}
                      maxWidth="100%"
                      name="notes"
                      onChange={handleChange}
                      label="Notes"
                      type="textarea"
                      placeholder="Notes"
                      maxLength={500}
                    />
                    <div className="mt-1 text-sm text-right text-gray-500">
                      <span>{state.notes?.length || 0}</span>
                      <span>/ 500</span>
                    </div>
                  </div>
                </div>
              </div>
              <PopupFooter
                onClose={onClose}
                onConfirm={handleSave}
                confirmLabel="Save"
                disabled={isLoading}
              />
            </div>
          </div>
        </CustomDraggable>
      </div>
    </ReactPortal>
  );
};

export default NewClaimStatusPopup;
